// 버전 체크 유틸리티
// ⚠️ 메인 버전 체크는 public/index.html 인라인 스크립트에서 수행됩니다.
// 이 파일은 URL 정리 등 보조 기능만 담당합니다.

import { VERSION_KEY } from './version';

/**
 * URL에서 cache-busting 파라미터 제거 (하드 리로드 후 정리)
 * index.html에서도 동일한 코드가 있지만, SPA 네비게이션 후에도 정리되도록 여기에도 포함
 */
export const cleanupCacheBustingParam = () => {
  const url = new URL(window.location.href);
  if (url.searchParams.has('_cb')) {
    url.searchParams.delete('_cb');
    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    console.log('Cache-busting parameter cleaned up');
  }
};

/**
 * 앱 시작 시 초기화 (URL 정리만 수행)
 * 버전 체크는 index.html 인라인 스크립트에서 이미 완료됨
 */
export const initVersionCheck = () => {
  if (window.versionCheckInitialized) {
    return;
  }
  window.versionCheckInitialized = true;

  // URL 정리
  cleanupCacheBustingParam();

  console.log('Version check system initialized');
};

// VERSION_KEY export (다른 곳에서 사용 가능)
export { VERSION_KEY };
